import * as React from 'react';
import { ReactComponent as TutorialIconSVG } from '../../assets/icons/mevo/ic-tutorial.svg';
import IconPattern, { IconProps } from './_IconPattern';

const TutorialIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={TutorialIconSVG} variantPlaces={[4, 5]} {...props} />;
};

export default TutorialIcon;
